import React from 'react';
import { useOpenEntityDetailOptional } from '../contexts/OpenEntityDetailContext';
import { CharacterDetail } from './CharacterDetail';
import { LocationDetail } from './LocationDetail';
import {
  Dialog,
  DialogContent,
  DialogTitle,
} from './ui/dialog';
import { ENTITY_DETAIL_DIALOG_CONTENT_CLASSNAME } from './EntityDetailModalLayout';

export const OpenEntityDetailHost: React.FC = () => {
  const entityDetail = useOpenEntityDetailOptional();
  const request = entityDetail?.request ?? null;
  const onClose = entityDetail?.closeEntityDetail ?? (() => {});

  if (!request) {
    return null;
  }

  if (request.type === 'character' && request.documentId) {
    return (
      <Dialog open onOpenChange={(open) => !open && onClose()}>
        <DialogContent
          className={ENTITY_DETAIL_DIALOG_CONTENT_CLASSNAME}
          data-open-entity-detail=""
        >
          <DialogTitle className="sr-only">{request.label}</DialogTitle>
          <CharacterDetail
            documentId={request.documentId}
            projectId={request.projectId}
            characterId={request.id}
            isModal
            onClose={onClose}
            onDeleted={onClose}
          />
        </DialogContent>
      </Dialog>
    );
  }

  if (request.type === 'location' && request.documentId) {
    return (
      <Dialog open onOpenChange={(open) => !open && onClose()}>
        <DialogContent
          className={ENTITY_DETAIL_DIALOG_CONTENT_CLASSNAME}
          aria-describedby={undefined}
          data-open-entity-detail=""
        >
          <DialogTitle className="sr-only">{request.label}</DialogTitle>
          <LocationDetail
            documentId={request.documentId}
            projectId={request.projectId}
            locationId={request.id}
            isModal
            onClose={onClose}
            onDeleted={onClose}
          />
        </DialogContent>
      </Dialog>
    );
  }

  return null;
};
